import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface AnxietyBehavioursSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Pacing or fidgeting",
  "Sighing",
  "Withdrawing from others",
  "Becoming overly silly or hyperactive",
  "Shutting down",
  "Talking louder or faster",
  "Avoiding eye contact",
  "Asking repeated questions",
  "Tearfulness",
  "Expressing negative self-talk, e.g. 'I can't do this'",
  "Asking to leave the room, for example, to go to the bathroom",
  "Grumpy facial expression",
];

export const AnxietyBehavioursSection: React.FC<
  AnxietyBehavioursSectionProps
> = ({ values, otherValue, onCheckboxChange, onOtherChange, className }) => (
  <CollapsibleFormSection
    title="Select/describe the student's early warning signs or anxiety behaviours."
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label className="other-input-label" htmlFor="anxietyBehavioursOther">
        Other:
      </label>
      <input
        type="text"
        id="anxietyBehavioursOther"
        name="anxietyBehavioursOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
